export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5632.13a3c731.jpg";